import EFPicture from 'elem/compCommon/EFPicture';
import BigPhone from '@elem/SVGIcon/PowerBackup/BigPhone';
import PlugAndPlay from '@elem/SVGIcon/PowerBackup/PlugAndPlay';
import Design from '@elem/SVGIcon/PowerIndependence/Design';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function J() {
    const { useLang } = useGlobal();
    const { t } = useLang('powerindependence');
    const icons: any = [
        {
            icon: <BigPhone className="color" />,
            text: t('secJ_tag1'),
        },
        {
            icon: <Design />,
            text: t('secJ_tag2'),
        },
        {
            icon: <PlugAndPlay className="color" />,
            text: t('secJ_tag3'),
        },
    ];
    return (
        <div id="power-independence-J" className={`power-independence-J ${css['power-independence-J']}`}>
            <div className="img-box">
                <EFPicture
                    src="/responsive/picture/power-independence/9.jpg"
                    srcMobile="/responsive/picture/power-independence/9_375.jpg"
                    srcPad="/responsive/picture/power-independence/9_375.jpg"
                    alt={t('secJ_title')}
                />
                <div className="text-content">
                    <p className="title">{t('secJ_title')}</p>
                    <p className="desc">{t('secJ_desc')}</p>
                    <ul className="icons">
                        {icons?.map((icon: any) => (
                            <li className="icon-item" key={icon?.text}>
                                {icon?.icon}
                                <p className="icon-text">{icon?.text}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
